"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyMaskedBrazilianPhones = void 0;
/**
 * @description Valida um número de telefone brasileiro com mascaras (XX) XXXX-XXXX ou (XX) XXXXX-XXXX.
 * @param {string} phone - O número de telefone a ser validado.
 * @returns Retorna `true` se o número de telefone for válido, caso contrário, retorna `false`.
 */
function verifyMaskedBrazilianPhones(phone) {
  const cellMask = /^\+55 \(\d{2}\) \d{5}-\d{4}$/;
  const phoneMask = /^\+55 \(\d{2}\) \d{4}-\d{4}$/;
  return cellMask.test(phone) || phoneMask.test(phone);
}
exports.verifyMaskedBrazilianPhones = verifyMaskedBrazilianPhones;